import styled from 'styled-components';

import { MOBILE_NAVIGATION_HEIGHT } from '@pkg/components/MainNavigationMobile/styles';

export const GroupsCompareWrapper = styled.div`
    margin-left: 16px;
`;

export const SideSheetInner = styled.div`
    height: auto;
    width: 100%;
`;

export const Heading = styled.h3`
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.white};
    font-family: 'Alliance No.1';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -2%;
    line-height: 25px;
    margin: 10px 0 22px 0;
    white-space: nowrap;
    display: inline-block;
`;

export const Subheading = styled.h4`
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.white};
    font-family: 'Alliance No.1';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin: 0;
    letter-spacing: -3%;
    line-height: 17px;
    display: inline-block;
`;

export const MobileButton = styled.div`
    position: fixed;
    bottom: ${MOBILE_NAVIGATION_HEIGHT + 20}px;
    right: 20px;
    z-index: 2;
`;

export const GroupsCompareModalWrapper = styled.div`
    .yat-modal-side-sheet {
        padding: 20px;
        z-index: 12;
    }
`;

export const Buttons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;
